// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"6e0045c8","941":"1facf5a0","977":"23814c44","986":"c6e4a1c9"}[chunkId] + ".chunk.js";
};